// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"RewindCamPlayer_videoPlayer__AX10U"};